module.exports = __webpack_public_path__ + "img/time-badge-start.16545b6b.svg";